var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7075 16.7071L12.7075 26.7071C12.6146 26.8 12.5043 26.8737 12.3829 26.924C12.2615 26.9743 12.1314 27.0001 12 27.0001C11.8686 27.0001 11.7385 26.9743 11.6171 26.924C11.4957 26.8737 11.3854 26.8 11.2925 26.7071C11.1996 26.6142 11.1259 26.5039 11.0756 26.3825C11.0253 26.2611 10.9995 26.131 10.9995 25.9996C10.9995 25.8682 11.0253 25.7381 11.0756 25.6167C11.1259 25.4953 11.1996 25.385 11.2925 25.2921L20.5863 15.9996L11.2925 6.70708C11.1049 6.51944 10.9995 6.26494 10.9995 5.99958C10.9995 5.73422 11.1049 5.47972 11.2925 5.29208C11.4801 5.10444 11.7346 4.99902 12 4.99902C12.2654 4.99902 12.5199 5.10444 12.7075 5.29208L22.7075 15.2921C22.8005 15.385 22.8742 15.4952 22.9246 15.6166C22.9749 15.738 23.0008 15.8682 23.0008 15.9996C23.0008 16.131 22.9749 16.2611 22.9246 16.3825C22.8742 16.5039 22.8005 16.6142 22.7075 16.7071Z",
    fill: "#343330"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caretRight.7cb8ef4f38222a2178b8991575ca9c78.svg";
export { ForwardRef as ReactComponent };